<template>
  <div class="text-content">
    <div class="content" :style="{'max-height': overflowHeight && !isExpand ? overflowHeight + 'px': 'none'}">
      <div class="text" ref="content">{{ content }}</div>
    </div>
    <span @click="toggle" v-if="!isExpand && height > overflowHeight">展开<i class="iconfont icon-down1"></i></span>
    <span @click="toggle" v-if="isExpand && height > overflowHeight">收起<i class="iconfont icon-up"></i></span>
  </div>
</template>

<script>
export default {
  name: 'OverflowHiddenComponent',
  props: {
    content: String,
    overflowHeight: {
      type: Number,
      default: 100
    }
  },
  data () {
    return {
      height: 0,
      isExpand: false
    }
  },
  mounted () {
    this.$nextTick(() => {
      setTimeout(() => {
        this.height = this.$refs.content.clientHeight
        console.log(this.height)
      })
    })
  },
  methods: {

  },
  watch: {
    content () {
      this.$nextTick(() => {
        this.height = this.$refs.content.clientHeight
        console.log(this.height)
      })
      
    }
  },
  methods: {
    toggle () {
      this.isExpand = !this.isExpand
    }
  }
}
</script>

<style lang="scss" scoped>
.text-content{
  .content{
    overflow: hidden;
  }
  .text{
    line-height: 20px;
    color: $--color-text-secondary;
    // overflow: hidden;
    // &.overflow{
    //   max-height: 100px;
    //   overflow: hidden;
    // }
  }
  span{
    cursor: pointer;
    i{
      margin-left: 6px;
      font-size: 12px;
    }
    &:hover{
      color: $--color-primary;
    }
  }
}
</style>